export const AppConstants = {
  defaultPending: window.self !== window.top,
  defaultDark: false,
  defaultTheme: 'Light',
  defaultScale: 11,
  defaultLocale: 'en-ZA',
  defaultDateFormat: 'DD/MM/YYYY',
  defaultInputStyle: 'outlined'
};
